// Install plugins
gsap.registerPlugin(SplitText);
gsap.registerPlugin(ScrollTrigger);

// Split text of HTML element into words and animate
document.querySelectorAll('.split--from--bottom').forEach((el) => {
  ScrollTrigger.create({
    trigger: el,
    start: 'top bottom',
    onEnter: () => {
      let split = SplitText.create(el, { type: 'words, line' });
      gsap.from(split.words, {
        y: 30,
        autoAlpha: 0,
        stagger: 0.1,
        duration: 1,
        ease: 'power2.out',
      });
    },
  });
});

// Run split word animation after initial load
const runSplitAnimation = (content) => {
  if (content && !content.classList.contains('split--done')) {
    content.classList.add('split--done');
    let split = SplitText.create(content, { type: 'words' });
    gsap.from(split.words, {
      y: 30,
      autoAlpha: 0,
      stagger: 0.1,
      duration: 1,
      ease: 'power2.out',
    });
  }
};

// Run animate line animation after initial load
const runLineInAnimation = (content) => {
  let split;
  SplitText.create(content, {
    type: 'words,lines',
    linesClass: 'line',
    autoSplit: true,
    mask: 'lines',
    onSplit: (self) => {
      split = gsap.from(self.lines, {
        duration: 0.6,
        yPercent: 100,
        opacity: 0,
        stagger: 0.1,
        ease: 'expo.out',
      });
      return split;
    },
  });
  split.timeScale(0.2).play(0);
};

// Stick section on scroll, animate background and fade in/out its text

gsap.set('.content--split--fade', { opacity: 0, position: 'absolute' });
gsap.set('.content--split', { opacity: 0 });

const addAnimations = (container, zIndex, isCustomSticky) => {
  // Assign increasing z-index to avoid overlapping content
  container.style.zIndex = zIndex;
  container.style.position = 'relative';

  const backgroundSticky = container.querySelector('.backround-sticky');
  const contentSplitFade = container.querySelector('.content--split--fade');
  const contentFade = container.querySelector('.content--fade');
  const contentSplit = container.querySelector('.content--split');

  if (backgroundSticky) {
    // Pin background image/video to create parallax effect
    if (!isCustomSticky) {
      ScrollTrigger.create({
        trigger: container,
        start: 'top top',
        end: '+=100%',
        pin: backgroundSticky,
        pinSpacing: false,
        scrub: true,
      });
    }

    // Zoom in/out the background image
    gsap.fromTo(
      backgroundSticky,
      {
        scale: 1.1,
      },
      {
        scale: 1,
        duration: 1.2,
        scrollTrigger: {
          trigger: container,
          start: 'top bottom',
          end: 'bottom top',
          scrub: 0.8,
        },
      }
    );

    // Opacity of dark overlay
    const overlay = container.querySelector('.dark-overlay');
    if (overlay) {
      ScrollTrigger.create({
        trigger: container,
        start: 'bottom bottom',
        end: 'bottom top',
        invalidateOnRefresh: true,
        onUpdate: (self) => {
          overlay.style.opacity = self.progress * 0.8;
        },
      });
    }
  }

  // Content with split animation on title and fade in/out on scroll
  if (contentSplitFade) {
    let top = isCustomSticky ? 'top top' : 'top bottom-=220';
    let bottom = isCustomSticky ? 'top top' : 'bottom bottom';
    if (container.classList.contains('produt-card-banner')) {
      top = 'top+=150 bottom-=220';
    }

    ScrollTrigger.create({
      trigger: container,
      start: top,
      end: bottom,
      onEnter: () => {
        const isImageBannerOnMobile = isCustomSticky && window.innerWidth < 1025;
        if (!isImageBannerOnMobile) {
          const rect = contentSplitFade.getBoundingClientRect();
          contentSplitFade.style.position = 'fixed';
          contentSplitFade.style.width = `${rect.width}px`;
          contentSplitFade.style.height = `${rect.height}px`;
        }

        gsap.set(contentSplitFade, { opacity: 1 });
        runSplitAnimation(contentSplitFade.querySelector('h2'));

        container.timeline = gsap
          .timeline({
            scrollTrigger: {
              trigger: container,
              start: 'bottom bottom',
              end: 'bottom top',
              scrub: true,
            },
          })
          .fromTo(
            contentSplitFade,
            {
              opacity: 1,
            },
            {
              opacity: 0.4,
              duration: 1,
            }
          );
      },
      onEnterBack: () => {
        const rect = contentSplitFade.getBoundingClientRect();
        contentSplitFade.style.position = 'fixed';
        contentSplitFade.style.width = `${rect.width}px`;
        contentSplitFade.style.height = `${rect.height}px`;
      },
      onLeaveBack: () => {
        const rect = contentSplitFade.getBoundingClientRect();
        contentSplitFade.style.position = 'absolute';
        contentSplitFade.style.width = `${rect.width}px`;
        contentSplitFade.style.height = `${rect.height}px`;
      },
      onLeave: () => {
        contentSplitFade.style.position = 'absolute';
      },
    });
  }

  // Content with fade in/out on scroll
  if (contentFade) {
    container.timeline = gsap
      .timeline({
        scrollTrigger: {
          trigger: container,
          start: 'bottom bottom-=50',
          end: 'bottom top',
          scrub: true,
        },
      })
      .fromTo(
        contentFade,
        {
          opacity: 1,
        },
        {
          opacity: 0,
          duration: 1,
        }
      );
  }

  // Content with split animation on title
  if (contentSplit) {
    ScrollTrigger.create({
      trigger: container,
      start: 'top top+=10',
      end: '+=100',
      onEnter: () => {
        gsap.set(contentSplit, { opacity: 1 });
        runSplitAnimation(contentSplit.querySelector('h2'));
      },
    });
  }
};

document.querySelectorAll('.content-for-layout .shopify-section').forEach((section, index) => {
  const productCards = section.querySelectorAll('.produt-card-banner');
  const baseZIndex = index * 100 + 1;
  if (productCards.length == 0) {
    const innerDiv = section.querySelector('.section-sticky');
    addAnimations(section, baseZIndex, innerDiv != null);
  } else {
    productCards.forEach((card, index) => {
      addAnimations(card, baseZIndex + index, false);
    });

    const specsSection = section.querySelector('.consoles-specs');
    if (specsSection) {
      addAnimations(specsSection, baseZIndex + productCards.length + 1, false);
    }
  }
});

// Assign high z-index to header,footer,announcement to avoid any view overlaps
const headerSection = document.querySelector('#shopify-section-header');
if (headerSection) {
  headerSection.style.zIndex = 9999;
}

const footerSection = document.querySelector('#shopify-section-footer');
if (footerSection) {
  footerSection.style.zIndex = 9999;
}

const announcementBarSection = document.querySelector('#shopify-section-announcement-bar');
if (announcementBarSection) {
  announcementBarSection.style.zIndex = 9999;
}

// Fade in text
document.querySelectorAll('.fade-in').forEach((element, index) => {
  element.timeline = gsap
    .timeline({
      scrollTrigger: {
        trigger: element,
        start: 'top bottom',
        end: 'bottom top',
      },
    })
    .fromTo(
      element,
      {
        opacity: 0,
      },
      {
        opacity: 1,
        duration: 2,
      }
    );
});

// Fade out text
document.querySelectorAll('.fade-out').forEach((element, index) => {
  element.timeline = gsap
    .timeline({
      scrollTrigger: {
        trigger: element,
        start: 'bottom 60%',
        end: 'bottom top',
        scrub: 0.6,
      },
    })
    .fromTo(
      element,
      {
        opacity: 1,
      },
      {
        opacity: 0,
        duration: 1,
      }
    );
});

// Animate footer logo
const runFooterAnimation = () => {
  const footerIcon = document.querySelector('.footer__icon');
  const footerIconBackground = footerIcon.querySelector('.footer--logo');

  footerIcon.timeline = gsap
    .timeline({
      scrollTrigger: {
        trigger: footerIcon,
        start: 'top bottom',
        end: 'bottom bottom',
        invalidateOnRefresh: true,
        scrub: 0.8,
      },
    })
    .fromTo(
      footerIconBackground,
      {
        rotate: `-25deg`,
      },
      {
        rotate: `0deg`,
        transformOrigin: 'center',
        duration: 1.5,
      }
    );
};
runFooterAnimation();

// Image with text animations
document.querySelectorAll('.section-image-with-text').forEach((section, index) => {
  const heading = section.querySelector('h2');
  if (heading) {
    gsap.set(heading, { opacity: 0 });
    ScrollTrigger.create({
      trigger: heading,
      start: 'top bottom',
      onEnter: () => {
        gsap.set(heading, { opacity: 1 });
        runSplitAnimation(heading);
      },
    });
  }
});

document.querySelectorAll('.reveal--wrapper').forEach((wrapper, index) => {
  const content = wrapper.querySelector('.reveal--content');
  gsap.set(content, { opacity: 0 });

  ScrollTrigger.create({
    trigger: wrapper,
    start: 'top 80%',
    onEnter: () => {
      // Create the mask
      const mask = document.createElement('div');
      mask.classList.add('reveal-mask');
      const colorSchemeClass = Array.from(wrapper.parentNode.classList).find((cls) => cls.startsWith('color-scheme-'));
      if (colorSchemeClass) {
        mask.classList.add(colorSchemeClass);
      }

      wrapper.style.position = 'relative';
      wrapper.appendChild(mask);

      // Animate the mask
      gsap.to(mask, {
        width: 0,
        duration: 1.2,
        ease: 'power2.out',
        onComplete: () => {
          mask.remove();
        },
      });

      // Animate content opacity
      gsap.to(content, {
        opacity: 1,
        duration: 1,
        ease: 'power2.out',
      });
    },
    once: true,
  });
});

// Refresh scrolltrigger on page resize
if (window.innerWidth >= 1024 && !document.body.classList.contains('theme-editor')) {
  window.addEventListener('resize', () => {
    location.reload();
  });
}

// Refresh scrolltrigger on load
window.addEventListener('load', () => {
  ScrollTrigger.refresh();
});
